import { CHOWNOW_SALES_GROUP_NAME, ROLE_SALES } from 'constants/auth';
import { isAdminUser, isAuthorizedForRole, isUserInGroup } from 'libs/auth';

import { CHOWNOW_CATEGORIES_TO_ENABLE_INTEGRATION } from './ChowNowIntegration.constants';

export function isChowNowIntegrationAllowed({ user, userRole, category }) {
  const isRestaurant = CHOWNOW_CATEGORIES_TO_ENABLE_INTEGRATION.includes(category);

  if (!isRestaurant) {
    return false;
  }

  if (isAdminUser(user)) {
    return true;
  }

  return isAuthorizedForRole(userRole, ROLE_SALES) && isUserInGroup(CHOWNOW_SALES_GROUP_NAME);
}
